<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>Assign Vendors to Site</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <p>
          Please select all of your vendors you would like to add to the site by
          clicking on each vendor below. Once Complete, please click on the ADD
          VENDORS TO SITE button.
        </p>
        <div style="height: 500px">
          <app-company-vendors-grid
            [suppliedQueryData]="suppliedGridQueryData"
            [rowMultiSelectWithClick]="true"
            [rowSelectionType]="'multiple'"
            (selectionChanged)="onSelectionChange($event)"
            [gridName]="'ClientVendors'"
          ></app-company-vendors-grid>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col-2">
          <button type="button" class="btn btn-danger" (click)="close()">
            Cancel
          </button>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="disableAssignVendorBtn"
            (click)="addVendorsToSite()"
          >
            Add Vendors To Site
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
